module.exports = __webpack_public_path__ + "static/img/12areaA_07.00727ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/12areaA_07.png
// module id = 1007
// module chunks = 1